var render = function render(){
  var _vm$deliverysite$cust, _vm$deliverysite, _vm$deliverysite2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-deliverysite-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm.deliverysite ? _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [(_vm$deliverysite$cust = _vm.deliverysite.customer_data) !== null && _vm$deliverysite$cust !== void 0 && _vm$deliverysite$cust.external && _vm.isNew ? _c('Warning', {
    attrs: {
      "elevation": 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("external_customer_deliverysite_instructions")) + " ")]) : _vm._e(), _vm.deliverysite.entity_data && _vm.deliverysite.entity_data.archived ? _c('v-alert', {
    attrs: {
      "outlined": "",
      "border": "left",
      "type": "warning",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("customerArchivedCannotModify")) + " ")]) : _vm._e(), _vm.readonly ? _c('v-alert', {
    attrs: {
      "outlined": "",
      "border": "left",
      "type": "warning",
      "dense": "",
      "text": ""
    }
  }, [_vm.deliverysite.entity && _vm.deliverysite.entity !== _vm.current_entity_id ? [_vm._v(" " + _vm._s(_vm.$translate("readonly_other_entity")) + " ")] : _vm.deliverysite.customer && _vm.deliverysite.customer_data.owner !== _vm.current_entity_id ? [_vm._v(" " + _vm._s(_vm.$translate("readonly_customer")) + " ")] : (_vm$deliverysite = _vm.deliverysite) !== null && _vm$deliverysite !== void 0 && _vm$deliverysite.stock ? [_vm._v(" " + _vm._s(_vm.$translate("readonly_stock")) + " ")] : (_vm$deliverysite2 = _vm.deliverysite) !== null && _vm$deliverysite2 !== void 0 && _vm$deliverysite2.archived ? [_vm._v(" " + _vm._s(_vm.$translate("readonly_archived")) + " ")] : _vm._e()], 2) : _vm._e(), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-information-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("information")))])], 1), _c('v-row', {
    staticClass: "stitch-modal__fields",
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "error-messages": _vm.deliverysite_errors.name,
      "label": _vm.$translate('addressNameRequired'),
      "placeholder": _vm.$translate('addressNamePlaceholder'),
      "disabled": _vm.readonly,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.deliverysite.name,
      callback: function callback($$v) {
        _vm.$set(_vm.deliverysite, "name", $$v);
      },
      expression: "deliverysite.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.deliverysite_errors.instructions,
      "label": _vm.$translate('instructions'),
      "placeholder": _vm.$translate('instructionsPlaceholder'),
      "name": "instruction",
      "rows": "3",
      "disabled": _vm.readonly,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.deliverysite.instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.deliverysite, "instructions", $$v);
      },
      expression: "deliverysite.instructions"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("address")))])], 1), _c('AddressForm', {
    attrs: {
      "title": '',
      "errors": _vm.deliverysite_errors.address,
      "readonly": _vm.readonly,
      "outlined": ""
    },
    model: {
      value: _vm.deliverysite.address,
      callback: function callback($$v) {
        _vm.$set(_vm.deliverysite, "address", $$v);
      },
      expression: "deliverysite.address"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-clock-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("deliveryHours")))])], 1), _c('DeliveryHoursEditor', {
    ref: "hoursEditor",
    attrs: {
      "readonly": _vm.readonly,
      "hide-title": ""
    },
    model: {
      value: _vm.deliverysite.delivery_hours,
      callback: function callback($$v) {
        _vm.$set(_vm.deliverysite, "delivery_hours", $$v);
      },
      expression: "deliverysite.delivery_hours"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _c('template', {
    slot: "bottom"
  }, [!_vm.readonly ? [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto text-none",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("cancel")) + " ")]), _c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3 text-none",
    attrs: {
      "color": "primary",
      "loading": _vm.deliverysite_saving,
      "disabled": _vm.deliverysite_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.save_text) + " ")])] : [_c('v-btn', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto text-none",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("close")) + " ")])]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }